/**
 * DataChart Constants
 */

export const DEFAULT_COLOR = "#1976d2";
export const DEFAULT_POINT_SIZE = 6;
export const LOCALE = "de-DE";
export const CHART_HEIGHT = 420;
export const POINT_VISIBILITY_THRESHOLD = 1000;
